module.exports = __webpack_public_path__ + "img/pie-chart.6bf2ec19.png";